import { createWebHistory, createRouter } from "vue-router";
import CrmApp from "@/app/CrmApp.vue";
import SocicalApp from "@/app/SocicalApp.vue";
// import TimesheetApp from "@/app/TimesheetApp.vue";
import PersonalApp from "@/app/PersonalApp.vue";
import HomeApp from "@/app/HomeApp.vue";
import LoginApp from "@/app/LoginApp.vue";
import LoginAppForgotEmail from "@/app/components/login/ForgotEmail.vue";
import LoginAppForgotPassword from "@/app/components/login/ForgotPassword.vue";
import LoginAppSetPassword from "@/app/components/login/SetPassword.vue";
const routes = [];
routes.push(
  { path: "/", name: "Home", component: HomeApp },
  { path: "/login", name: "app.login", component: LoginApp },
  {
    path: "/forgot-email",
    name: "app.login.forgot_email",
    component: LoginAppForgotEmail,
  },

  {
    path: "/forgot-password",
    name: "app.login.forgot_password",
    component: LoginAppForgotPassword,
  },
  {
    path: "/forgot-password/reset",
    name: "app.login.setpass",
    component: LoginAppSetPassword,
  },
  // { path: '/timesheet', name: 'app.timesheet', component: TimesheetApp },
  // {
  //     path: '/timesheet/:pathMatch(.*)*',
  //     component: TimesheetApp
  // },

  { path: "/personal", name: "app.personal", component: PersonalApp },
  {
    path: "/personal/:pathMatch(.*)*",
    component: PersonalApp,
  },

  { path: "/crm", name: "app.crm", component: CrmApp },
  {
    path: '/crm/:pathMatch(.*)*',
    component: CrmApp
  },
  { path: '/socical', name: 'app.socical', component: SocicalApp },
  {
    path: '/socical/:pathMatch(.*)*',
    component: SocicalApp
  },
  
);

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  let user = localStorage.getItem("user");

  const publicPages = [
    "/login",
    "/register",
    "/forgot-password",
    "/forgot-password/reset",
    "/user-profile",
    "/auth/check",
    "/auth/refresh",
  ];
  const dynamicRoutes = [/^\/crm\/tours\/rate\/customer\/[a-fA-F0-9-]+$/];
  const isDynamicRoute = (path) =>
    dynamicRoutes.some((pattern) => pattern.test(path));
  const isAuthPage = !publicPages.includes(to.path) && !isDynamicRoute(to.path);

  if (!isAuthPage) {
    return next();
  }

  // const authRequired = to?.matched[to.matched.length - 1]?.meta?.authRequired??true;

  //await dataStore.initializeData();
  if (!isAuthPage) {
    return next();
  }

  // Kiểm tra nếu URL chứa '/login' nhưng không phải là '/login' chính xác
  if (to.path.includes("/login") && to.path !== "/login") {
    let $next = "";
    if(!window.location.href.includes("?next") &&
    !window.location.href.includes("/login")){
      $next = "?next=${window.location.href}`";
    }

    return next(`/login`+$next);
  }
  // Danh sách các route không cần xác thực
  const publicRoutes = [
    "/login",
    "/crm/register",
    "/crm/forgot-password",
    "/forgot-email",
  ];

  // Kiểm tra nếu route hiện tại là route công khai
  if (publicRoutes.includes(to.path)) {
    return next();
  }

  // Kiểm tra xác thực cho các route khác

  if (!user) {
    return next(`/login`);
  }

  next();
});

export default router;
